/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Container, Box, Text, Section, Link } from '@tishman/components';
import React from 'react';

interface StoryBuyTicketsBlockProps {
  buyTicketsBlock: {
    text: string;
    ctaText: string;
    ctaLink: string;
  };
}

const StoryBuyTicketsBlock = (
  props: StoryBuyTicketsBlockProps,
): React.JSX.Element => {
  const { text, ctaText, ctaLink } = props.buyTicketsBlock;

  return (
    <Section data-section="StoryBuyTickets" {...props}>
      <Container mb={[3, 6]} px={[null, 0]} sx={{ width: '100%' }}>
        <Box sx={{ my: '25px' }}>
          <Text
            sx={{
              fontWeight: 'regular',
              lineHeight: '25px',
            }}
          >
            {text}
          </Text>
        </Box>
        <Link href={ctaLink} sx={{ fontWeight: 'medium' }} variant="underline">
          {ctaText}
        </Link>
      </Container>
    </Section>
  );
};

export default StoryBuyTicketsBlock;
